<template>
  <div class="paypal-settings">
    <Header />
    <div class="settings-main">
      <div class="settings-navigation">
        <SettingsNavigation></SettingsNavigation>
      </div>
      <div class="paypal">
        <div class="paypal-main">
          <p class="indentation">
            एक पेइपाल एक खाता से मिलाता है, जो परिवर्धित नहीं किया जा सकता इस
            सुधार के बाद। कृपया अपने बहुत से प्रयोग किया गया पैपाल भरें खाता
          </p>

          <div class="input-boxs">
            <div>Paypal</div>
            <input
              type="text"
              v-model="paypal"
              placeholder="कृपया पेइपाल भरें"
              :class="oldPaypal ? 'disabled' : ''"
              :disabled="oldPaypal ? true : false"
            />
          </div>
          <div class="input-boxs">
            <div>पूरा नाम</div>
            <input
              type="text"
              v-model="name"
              placeholder="कृपया पूरा नाम भरें"
              :class="oldName ? 'disabled' : ''"
              :disabled="oldName ? true : false"
            />
          </div>
          <div
            :class="['update', { 'update-check': oldName && oldPaypal }]"
            @click="submit"
          >
            <div>PayPal बदलें</div>
          </div>
        </div>
      </div>
      <div class="settings-avatarurl">
        <AvatarUrl></AvatarUrl>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import Header from "./mycom/header.vue";
import Footer from "./mycom/footer.vue";
import SettingsNavigation from "./mycom/settingsNavigation.vue";
import AvatarUrl from "./mycom/avatarUrl.vue";
import { Notify } from "vant";
import Account from "./mycom/account.vue";
import { accountsPaypal, users, accounts } from "@/api/api.js";
export default {
  components: { Header, Footer, SettingsNavigation, AvatarUrl, Account },
  data() {
    return {
      checked: false,
      oldPaypal: "",
      paypal: "",
      oldName: "",
      name: "",
    };
  },
  methods: {
    submit() {
      if (this.oldName && this.oldPaypal) return;
      this.setInfo();
    },
    async getName() {
      const loginInfo = JSON.parse(localStorage.getItem("LOGIN_INFO"));
      const params = {
        id: loginInfo.id,
      };
      await users(params).then((res) => {
        //console.log(res);
        if (res.code === 200) {
          console.log("res", res.data);
          this.oldName = res.data.name;
        } else {
          Notify({ type: "danger", message: res.errors[0] });
        }
      });
    },
    async initPage() {
      //用户信息
      const loginInfo = JSON.parse(localStorage.getItem("LOGIN_INFO"));
      const params = {
        id: loginInfo.id,
      };
      await accounts(params).then((res) => {
        if (res.code === 200) {
          this.$store.commit("setAccountInfo", res.data);
          this.oldPaypal = res.data.paypal;
        } else {
          Notify({ type: "danger", message: res.errors[0] });
        }
      });
    },
    setInfo() {
      const params = {
        type: 1,
        name: this.name,
        account: this.paypal,
      };
      accountsPaypal(params).then((res) => {
        if (res.code === 200) {
          this.oldPaypal = this.paypal;
          this.oldName = this.name;
          Notify({ type: "primary", message: "Successfully set" });
        } else {
          Notify({ type: "warning", message: res.errors });
        }
      });
    },
  },
  async created() {
    console.log(1234);
    await this.initPage();
    await this.getName();
    console.log("this.oldname", this.oldName);
    if (this.oldPaypal) {
      this.paypal = this.oldPaypal;
    }
    if (this.oldName) {
      this.name = this.oldName;
    }
  },
};
</script>
<style scoped>
.paypal-settings {
  padding-top: 40px;
  min-height: calc(100vh - 40px);
  background-color: #fff;
}
header {
  position: fixed;
  top: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  background: #ffffff;
  z-index: 999;
  box-shadow: 0px 3px 6px 1px #c6c5c6;
}
.settings-main {
  width: calc(100% - 175px);
  padding: 20px 87.5px;
  display: flex;
}
.paypal {
  width: 100%;
}
.paypal-main {
  width: 337.5px;
  margin-left: 40.625px;
}
.paypal-main > p {
  font-size: 10px;
  color: #232323;
  margin-bottom: 15px;
  line-height: 15px;
}
input {
  width: calc(100% - 11.25px);
  height: 28px;
  line-height: 28px;
  border-radius: 1.25px;
  border: 0.625px solid #dddddd;
  padding-left: 10px;
  font-size: 10px;
}
.input-boxs > div {
  font-size: 10px;
  margin-bottom: 7px;
  margin-top: 20px;
}
.explain {
  margin-top: 12.5px;
  font-size: 10px;
  line-height: 15px;
  margin-bottom: 12.5px;
}
.wide {
  font-weight: bold;
  font-size: 10px;
  line-height: 15px;
  margin-bottom: 22.5px;
}
.info {
  font-size: 10px;
  margin-bottom: 10px;
}
.update {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
.update > div {
  width: 81.875px;
  height: 22.5px;
  border-radius: 1.5px;
  border: 0.625px solid #2e67ea;
  text-align: center;
  line-height: 22.5px;
  margin-top: 30px;
  color: #2e67ea;
  font-size: 10px;
  cursor: pointer;
}
.update-check > div {
  background-color: #f5f7fa;
  color: #dcdbe2;
  border: 0.625px solid #ddd;
}
.indentation {
  text-indent: 2em;
}
.disabled {
  color: #dcdbe2;
  background-color: #f5f7fa;
  cursor: no-drop;
}
</style>
<style scoped>
/* 媒体查询 */
@media only screen and (max-width: 1280px) {
  .settings-main {
    width: calc(100% - 95px);
    padding: 20px 47.5px;
  }
}
@media only screen and (max-width: 1100px) {
  .settings-avatarurl {
    display: none;
  }
}
@media only screen and (max-width: 900px) {
  .settings-main {
    width: calc(100% - 45px);
    padding: 20px 27.5px;
  }
  .paypal-main {
    margin-left: 10px;
  }
}
@media only screen and (max-width: 800px) {
  .settings-main {
    width: calc(100% - 25px);
    padding: 20px 17.5px;
  }
  .paypal-main {
    margin-left: 10px;
  }
}
@media only screen and (max-width: 768px) {
  .settings-navigation {
    display: none;
  }
  .settings-main {
    width: 100%;
    padding: 20px 0;
  }
  .paypal-main {
    margin: 0 auto;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/setpaypal.vue